import { useMutation, useQuery, queryOptions } from "@tanstack/react-query";
import instance from "./axiosInstance";
import { WasteCode } from "types/wasteCode.type";

export type MostUsedWasteCode = {
  wasteCode: WasteCode;
  count: number;
};

export const ENDPOINT = "waste-code";

export enum WasteCodeQueryKeys {
  GetAll = "get-all-waste-codes",
  GetDropDown = "get--waste-code-dropdown",
  GetMostUsed = "get-most-used-waste-codes",
  CreateMany = "create-transport-document",
}

export const useWasteCodeDropDown = (query = "") =>
  useQuery({
    queryKey: [WasteCodeQueryKeys.GetDropDown, query],
    queryFn: async (): Promise<WasteCode[]> => {
      const response = await instance.get(`${ENDPOINT}/dropdown?q=${query}`);
      return response.data;
    },
  });

export const getMostUsedWasteCodes = (limit: number = 3) =>
  queryOptions({
    queryKey: [WasteCodeQueryKeys.GetMostUsed, limit],
    queryFn: async (): Promise<MostUsedWasteCode[]> => {
      const response = await instance.get(`${ENDPOINT}/most-used?limit=${limit}`);
      return response.data;
    },
  });

export const useCreateWasteCodes = () =>
  useMutation({
    mutationFn: async (payload: {
      codes: { code: string; description: string }[];
    }): Promise<void> => {
      return instance.post(ENDPOINT, payload);
    },
  });
